<div  class="tw-bg-orange-90 tw-border tw-border-orange-100 tw-py-4.5 tw-px-3 tw-rounded-3 tw-mx-4 tw-mb-6 tw-relative tw-overflow-hidden"
      (click)="handleClick()"
>
  <div class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-[3px] tw-bg-orange-400"></div>
  <div class="tw-flex tw-items-center">
    <img src="/assets/icons/orange-exclamation.png" alt="payment pending" class="tw-flex-none tw-h-8 tw-aspect-square tw-mr-2" />
    <div class="xs:tw-mr-1 tw-flex-1 tw-min-w-0">
      <p class="tw-font-lexend tw-font-[700] tw-text-300 tw-text-black" i18n="@@completeYourPaymentTitle">Complete your payment</p>

      <!-- >= xs: kit info sits under the title; Pay Now is the row-level button on the right -->
      <div class="tw-font-lexend tw-text-200 tw-text-gray-500 tw-hidden xs:tw-block">
        <ng-container *ngTemplateOutlet="kitInfo"></ng-container>
      </div>

      <!-- < xs: kit info and Pay Now share a single row under the title -->
      <div class="tw-flex tw-items-center xs:tw-hidden tw-justify-between tw-w-full tw-gap-1">
        <div class="tw-font-lexend tw-text-200 tw-text-gray-500">
          <ng-container *ngTemplateOutlet="kitInfo"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="payNow; context: { display: 'tw-flex' }"></ng-container>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="payNow; context: { display: 'tw-hidden xs:tw-flex' }"></ng-container>
  </div>
</div>

<ng-template #kitInfo>
  @if (isHairRegimen) {
    <span i18n="@@hairTreatmentKit">Hair treatment kit</span>&nbsp;&middot;
  } @else {
    <span i18n="@@skinTreatmentKit">Skin treatment kit</span>&nbsp;&middot;
  }
  <span>&#8377;{{ amount }}</span>
</ng-template>

<ng-template #payNow let-display="display">
  <div class="tw-flex-none tw-bg-teal-600 tw-text-white tw-font-lexend tw-font-semibold tw-text-200 tw-rounded-1.5 tw-py-[3px] tw-px-[9px] tw-justify-center tw-items-center shine-button tw-relative tw-overflow-hidden tw-ml-auto"
       [ngClass]="display"
       i18n="@@payNowButton">Pay Now</div>
</ng-template>
